'use strict';

require('../groups/CompanyGroupService.js');
require('../groups/CompanyGroupUserService.js');

function CompanySettingGroupsCtrl(
  $scope,
  $q,
  groups,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyCategoryService,
  CompanyGroupService,
  CompanyGroupUserService,
  growl
) {
  var origGroups = [];
  $scope.groups = groups;
  $scope.translations = translations;

  // Save each group object to a new array for comparison later
  $scope.groups.$promise.then(function() {
    for(var i = 0; i < $scope.groups.length; i++) {
      origGroups.push(angular.copy($scope.groups[i]));
    }
  });

  function saveGroup(group) {
    if( ! group.id) {
      return group.$save({companyId: $stateParams.companyId}, function(group, headers) {
        group.id = headers("location").split("/").pop();
        group.numPublications = 0;
        group.numUsers = 0;

        growl.addSuccessMessage(translations['settings.create-group-success'] + ': ' + group.name);

        if (group.addCurrentUser) {
          CompanyGroupUserService.save({
            companyId: $stateParams.companyId,
            groupId:   group.id
          }, $scope.currentUser, function() {
            group.numUsers = 1;
          });
        }

        return group;
      });
    }

    for(var i = 0; i < origGroups.length; i++) {
      if(origGroups[i].id === group.id) {
        if(angular.equals(origGroups[i], group)) {
          return $scope.createQ(function(resolve) {
            resolve(group);
          });
        }
        else {
          return group.$update({companyId: $stateParams.companyId, groupId: group.id});
        }
      }
    }

    return group.$update({companyId: $stateParams.companyId, groupId: group.id});
  }

  $scope.saveGroups = function() {
    return $q.all($scope.groups.map(saveGroup)).then(function(groups) {
      $scope.groups = groups;

      origGroups = angular.copy($scope.groups);

      $window.location.reload();

      growl.addSuccessMessage(translations['settings.create-group-success']);
    }, function() {
      growl.addErrorMessage(translations['settings.create-group-failure']);
    });
  };

  $scope.addGroup = function() {
    $scope.groups.push(new CompanyGroupService());

    $scope.lastItem = $scope.groups.length - 1;
  };

  $scope.deleteGroup = function(group) {
    group.$delete({companyId: $stateParams.companyId, groupId: group.id}, function() {
      function groupFilter(g) {
        return g.id !== group.id;
      }

      $scope.groups = $scope.groups.filter(groupFilter);
      origGroups    = origGroups.filter(groupFilter);

      growl.addSuccessMessage(translations['settings.remove-group-success']);
    }, function() {
      growl.addErrorMessage(translations['settings.remove-group-failure']);
    });
  };

}

CompanySettingGroupsCtrl.resolve = {
  groups: ['$stateParams', 'CompanyGroupService', function($stateParams, CompanyGroupService) {
    return CompanyGroupService.query({companyId: $stateParams.companyId, all: true}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'settings.create-group-category-success',
      'settings.create-group-category-failure',
      'settings.remove-group-category-success',
      'settings.remove-group-category-failure',
      'user.save-permissions-success',
      'user.save-permissions-failure'
    ]);
  }]
};
module.exports = CompanySettingGroupsCtrl;

angular.module('dokiv')
  .controller('CompanySettingGroupsCtrl', [
  '$scope',
  '$q',
  'groups',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyCategoryService',
  'CompanyGroupService',
  'CompanyGroupUserService',
  'growl',
  CompanySettingGroupsCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingGroupsCtrl.js
// module id = 408
// module chunks = 0